import type { ScopedProject } from "@domain/project/project-guards";
import { Exclude, Expose } from "class-transformer";
import { IsDate, IsNumber, IsOptional, IsString, IsUUID } from "class-validator";

export class ProjectFile {
  @Exclude()
  private project?: ScopedProject;

  @IsString()
  @Expose({ name: "name" })
  public name: string;

  @IsUUID()
  @IsOptional()
  public readonly id?: string;

  @IsString()
  public readonly projectId: string;

  @IsNumber()
  public readonly size: number;

  @IsString()
  public readonly type: string;

  @IsDate()
  public readonly uploadedAt: Date;

  constructor(name: string, projectId: string, size: number, type: string, uploadedAt: Date) {
    this.name = name;
    this.projectId = projectId;
    this.size = size;
    this.type = type;
    this.uploadedAt = uploadedAt;
  }

  init(project: ScopedProject) {
    this.project = project;
  }
}
